const ANIMATION_NAME = 'petition-marquee';

/**
 * The running CSS animation driving a marquee track, or undefined where it isn't there yet
 * (SSR, or a test environment without WAAPI).
 *
 * The 'animationName' in check (rather than instanceof CSSAnimation) keeps this safe in
 * engines without the CSSAnimation global, like jsdom.
 */
export function findMarqueeAnimation(track: HTMLElement): CSSAnimation | undefined {
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- jsdom has no getAnimations
	if (typeof track.getAnimations !== 'function') return undefined;
	return track
		.getAnimations()
		.find(
			(animation): animation is CSSAnimation =>
				'animationName' in animation && animation.animationName === ANIMATION_NAME,
		);
}
